const CryptoJS = require("crypto-js");


const secretKey = CryptoJS.enc.Hex.parse('LQ8yCTiDOFQFk8FFo1CpftkBoBnEIJmu')
const tokenSecretKey = CryptoJS.enc.Hex.parse('LQ8yCTiDOFQFk8FFo1CpftkBoBnEIJmu')
const isJSON = (str) => {
    try {
        return JSON.parse(str)
    }
    catch {
        return str
    }
}
// Encrypt
export const encrypt = (decryptedMessage) => (
    CryptoJS.AES.encrypt(JSON.stringify(decryptedMessage), secretKey, { mode: CryptoJS.mode.ECB }).toString()
)
// var ciphertext = CryptoJS.AES.encrypt('my message', 'secret key 123').toString();

// Decrypt

export const decrypt = (encryptedMessage) => {
    const bytes = CryptoJS.AES.decrypt(encryptedMessage, secretKey, { mode: CryptoJS.mode.ECB });
    return isJSON(bytes.toString(CryptoJS.enc.Utf8));
}

export const encryptToken = (decryptedMessage) => (
    CryptoJS.AES.encrypt(JSON.stringify(decryptedMessage), tokenSecretKey, { mode: CryptoJS.mode.ECB }).toString()
)
// var bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
// var originalText = bytes.toString(CryptoJS.enc.Utf8);

// console.log(originalText);
